import { v4 as uuidv4 } from "uuid";

export const superAdminLoginHeader = "I-9 Super Admin login";
export const forgotPasswordHeader = "Forgot Password?";
export const loginHeader = "I-9 login";
export const sessionExpired = "Your session has expired";
export const section2Completed = "Section 2 Complete";
export const childCompanyFeilds = [
  "childCompanyName",
  "childEverifyNumber",
  "street",
  "city",
  "childState",
  "zipCode",
];
export const invited = "Invited";
export const inactiveMessege =
  "You have been inactive for 15 minutes. Please return to complete your I-9 transaction.";
export const createdEmployeeDraftMsg =
  "";
export const documentPreviewContent =
  "The uploaded document will be used to auto-fill the I-9 form. Please review the information extracted from the document and ensure its accuracy before submission.";
export const documentDetailsKeys = {
  firstName: "First Name",
  middleName: "Middle Initial",
  lastName: "Last Name",
  mobileNumber: "Mobile Number",
  apartment: "Apartment Number",
  street: "Street Name & Number",
  city: "City",
  state: "State",
  country: "Country",
  zipcode: "Zip Code",
  dateOfBirth: "Date of birth",
  SSN: "Social Security Number",
  dateOfExpiration: "Expiration Date",
};

export const i9FormFieldNames = {
  firstName: "First Name",
  lastName: "Last Name",
  middleName: "Middle Initial",
  anyOtherLastName: "Other last names used",
  email: "Email",
  street: "Street Name & Number",
  apartment: "Apartment Number",
  city: "City",
  state: "State",
  zipCode: "Zip Code",
  countryIssuance: "Country of Issuance",
  ssn: "SSN",
  mobileNumber: "Mobile Number",
  dateOfBirth: "Date of Birth",
  citizenStatus: "Citizenship Status",
  uscisNumber: "USCIS A-Number",
  i94AdmissionNumber: "Form I-94 Admission Number",
  passportNumber: "Foreign Passport Number",
  expireDate: "Expiration Date",
  employeeSignature: "Signature",
  notes: "Notes",
};

export const i9DocumnentNames = {
  "u.s. passport": "passport",
  "green card": "green card",
  "ead form i-766": "EAD",
};

export const citizenStatusOptions = [
  { id: uuidv4(), value: 1, key: "A citizen of the United States" },
  { id: uuidv4(), value: 2, key: "A noncitizen national of the United States" },
  { id: uuidv4(), value: 3, key: "A lawful permanent resident" },
  {
    id: uuidv4(),
    value: 4,
    key: "A noncitizen authorized to work until",
    isSubOptionsAvailable: true,
    subOptions: [
      { id: uuidv4(), value: 5, key: "USCIS A-Number", subValue: true },
      {
        id: uuidv4(),
        value: 6,
        key: "Form I-94 Admission Number",
        subValue: true,
      },
      {
        id: uuidv4(),
        value: 7,
        key: "Foreign Passport Number",
        subValue: true,
      },
    ],
  },
];

export const listADocs = [{ id: uuidv4(), value: 1, key: "Passport" }];

export const verificationConstants = {
  fullInperson: {
    title: "Fully In Person",
    bodyMessageOne:
      "Employee will complete Section 1 and you will complete Section 2 in person within 3 days of the hire date.",
    bodyMessageTwo:
      "You can use the Auto complete feature to make this process faster.",
  },
  section2Inperson: {
    title: "Section 2 In Person",
    bodyMessageOne:
      "Employee will complete Section 1 online and you will complete Section 2 in person within 3 days of the hire date.",
    bodyMessageTwo:
      "The systems automated document detection features will allow you to do this with minimal data entry.",
  },
  remoteVerification: {
    title: "Remote Verification",
    bodyMessageOne:
      "This feature can be used if you are enrolled in E-Verify or Canary is your company's designated represented.",
    bodyMessageTwo:
      "The process is entirely online and is the most efficient way to process I-9s.",
  },
};

export const verificationTypeLabels = {
  1: verificationConstants.fullInperson.title,
  2: verificationConstants.section2Inperson.title,
  3: verificationConstants.remoteVerification.title,
};

export const validExtensions = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

export const signatureFonts = [
  { value: "Caveat, cursive", label: '"Caveat", cursive' },
  { value: "Dr Sugiyama, cursive", label: '"Dr Sugiyama", cursive' },
  { value: "Mrs Sheppards, cursive", label: "Mrs Sheppards, cursive" },
  { value: "Arizonia, cursive", label: "Arizonia, cursive" },
  {
    value: "Nothing You Could Do, cursive",
    label: "Nothing You Could Do, cursive",
  },
  { value: "Playball, cursive", label: "Playball, cursive" },
  { value: "Mr Dafoe, cursive", label: "Mr Dafoe, cursive" },
  { value: "Allura, cursive", label: "Allura, cursive" },
  {
    value: "lindsey-signature, sans-serif",
    label: "lindsey-signature, sans-serif",
  },
];

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

export const onlyNumbers = "Must be only digits";
export const companyNameError =
  "Company name is required with a maximum of 50 characters";
export const everifyError =
  "E-Verify number is required and must be 4 to 7 numerical characters";
export const designativeRepresentativeError =
  "Designative representative is required and must be selected";
export const reverificationError =
  "Reverification is required and must be selected";
export const reverificationReasonError =
  "Reverification reason is required with a maximum of 50 characters";
export const firstNameError =
  "First name is required with a maximum of 50 characters";
export const jobTitleError =
  "Job Title is required with a maximum of 50 characters";
export const lastNameRequiredError =
  "Last name is required with a maximum of 50 characters";
export const maxStringError = "Maximum of 50 characters allowed";
export const emailRequired = "Email is required";
export const invalidEmail = "Invalid email address";
export const selectError = "Please select one or more companies from Dropdown";
export const passwordMatch = "Passwords must match";
export const passwordrequired = "Password is required";
export const passwordrequirements =
  "Password must meet complexity requirements";
export const hireDaterequired = "Hire date is required";
export const hireDateInvalid = "Hire date is invalid";
export const dateInvalid = "Expiry date is invalid";
export const expiryDateRequired = "Expiry date is required";
export const invalidDOB =
  "Date of Birth is required and it must be a valid date";
export const dobNotADate = "Please enter a valid date of birth, as MM/DD/YYYY";
export const dobInFuture = "Date of Birth cannot be today or a future date";
export const mobileNumberInvalid = "Mobile number is not valid";
export const streetNameError = "Street Name and Number cannot be empty";
export const middleNameError =
  "Please enter N/A if you do not have any middle initial";
export const otherLastNameError =
  "Please enter N/A if you have not used any other last names";
export const cityError = "City cannot be empty";
export const stateError = "Please select one option from Dropdown";
export const zipCodeError = "ZIP Code must be a valid U.S. ZIP or Canadian postal code";
export const countryIssunaceError = "Please select one option from Dropdown";
export const emptyPassportNumber = "Foreign Passport Number is required";
export const uscisNumberRequired = "USCIS A-Number is required";
export const invaliduscisNumber = "Please enter a valid USCIS A-Number";
export const invalidi94AdmissionNumber =
  "Please enter a valid Form I-94 Admission Number";
export const emptyi94AdmissionNumber = "Form I-94 Admission Number is required";
export const passportExpireDate =
  "Please enter N/A if you do want to fill expire date";
export const ssnError =
  "Social Security Number must be in the format XXX-XX-XXXX";
export const ssnRequiredError = "Social Security Number cannot be empty";
export const signatureError = "Signature cannot be empty";
